import MachineTestimonials from "~/assets/machine-testimonials.gif";
import DynamicBoxHero from "~/assets/dynamic-box-hero.png";
import DynamicBoxHeroMobile from "~/assets/dynamic-box-hero-mobile.png";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <div className="hero-section">
      <h2 className="hero-section-title">Build Your Box</h2>
      <picture>
        <source
          media="(max-width: 768px)"
          srcSet="https://cdn.shopify.com/s/files/1/0038/6049/6433/files/dynamic-box-hero-mobile.png?v=1727989329"
        />
        <img
          className="hero-section-image"
          src="https://cdn.shopify.com/s/files/1/0038/6049/6433/files/dynamic-box-hero.png?v=1725640109"
          alt="Build Your Box"
          loading="lazy"
        />
      </picture>
      <img
        className="hero-section-machine-testimonial-image"
        src={MachineTestimonials}
        alt="Machine Testimonials"
        loading="lazy"
      />
    </div>
  );
};

export default HeroSection;
